import { lazyWithPreload, createComponentRegistry } from 'copilot-toolkit/js/custom-components';
const NAMESPACE = 'CONVERSATIONAL_ONBOARDING';
export const onboardingRegistryEntry = createComponentRegistry(NAMESPACE, {
  GTKM_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/GetToKnowMeCard')),
  STEP_INDICATOR: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/StepIndicator/StepIndicator')),
  CONTACTS_TABLE: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/prospecting-agent/ContactTable')),
  PIPELINE_COVERAGE_COMPANIES: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/prospecting-agent/PipelineCoverageCompaniesCard')),
  PIPELINE_NUMBERS_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/pipeline-coverage/PipelineNumbersCard')),
  PIPELINE_INTAKE_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/pipeline-coverage/PipelineIntakeCard')),
  TARGET_MARKET_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/segments/TargetMarketCard')),
  AI_LINK_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/segments/AILinkCard')),
  SEQUENCES_PREVIEW: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/sequences/SequencesPreview')),
  SEGMENT_PREVIEW: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/segments/SegmentPreview')),
  GENERIC_JOURNEY_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/GenericJourneyCard')),
  CONNECT_INBOX_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/data-sync/ConnectInboxCard')),
  INBOX_SYNC_SETUP_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/data-sync/InboxSyncSetupCard')),
  RECOMMENDED_NEXT_TASK: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/RecommendedNextTask')),
  JOURNEY_HANDOFF_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/JourneyHandoffCard')),
  BRAND_VISIBILITY_AUDIT_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/BrandVisibilityAuditCard')),
  CONTEXT_ANALYZED: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/ContextAnalyzed')),
  SECTION_HEADER: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/SectionHeader/SectionHeader')),
  AI_SETTINGS_CONSENT_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/AiSettingsConsentCard')),
  AGENT_PLAN_CARD: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/AgentPlanCard')),
  GENERIC_CARD_V2: lazyWithPreload(() => import( /* webpackChunkName: "breeze-onboarding-components" */
  './components/GenericCardV2'))
});